module.exports = __webpack_public_path__ + "img/poseCVPMidSansPI.1163033c.jpg";